import { useMsal } from '@azure/msal-react';
import { useParams } from 'react-router';
import WizardForm from '../../../components/forms/WizardForm';
import { WizardFormProps } from '../../../components/forms/WizardForm/types';
import WizardStep from '../../../components/forms/WizardForm/WizardStep';
import useHtmlTitle from '../../../components/Utilities/useHtmlTitle';
import useBodyClass from '../../../components/Utilities/useBodyClass';
import { FormStepStatus, FormStepStatusDto } from '../../../api/web-api-client';
import useAccountContext from '../../../authentication/hooks';
import ContactDetails from '../contactDetails';
import updateContactProps from './updateContactProps';

const updateContactWizardProps: WizardFormProps = {
    locationOnCompletion: '/',
    lastStepNextButtonTitle: 'Save and close',
    canSaveDraft: false,
    confirmationOnSubmission: {
        modalTitle: 'Update contact confirmation',
        modalBodyText: 'Are you sure you want to update this contact?',
        yesButtonTitle: 'Yes, submit',
        noButtonTitle: 'No, cancel',
    },
};

const statuses: FormStepStatusDto[] = [{ status: FormStepStatus.NotStarted }];

const UpdateContact = () => {
    const { accounts, instance } = useMsal();
    const { id } = useParams();
    const account = useAccountContext();

    const contactId: number = id !== undefined ? Number(id) : 0;
    useHtmlTitle('Update contact | NMI Services portal');
    useBodyClass('wizard');
    return (
        <WizardForm {...updateContactWizardProps}>
            <WizardStep {...updateContactProps(accounts, instance, statuses, account, contactId)}>
                <ContactDetails />
            </WizardStep>
        </WizardForm>
    );
};

export default UpdateContact;
